import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Button from '../Button/Button'
import Image from '../Image/Image'
import PartNumbers from '../PartNumbers/PartNumbers'
import SimpleStockInfo from '../SimpleStockInfo/SimpleStockInfo'
import { default as Pricing } from './Pricing'
import { productLandingPage } from './PDPHelpers'
import { connectToLocale } from '../Locale/Locale'

export function PDPDetails({
     abbreviation,
     contractDiscount,
     currencyCode,
     displayDiscount,
     displayListPrice,
     hasContractSection,
     isLoggedIn,
     isIPSUser,
     imageUrl,
     isOnMobile,
     listPrice,
     webPrice,
     priceInclVat,
     manufacturerId,
     manufacturerImage,
     mfrName,
     materialId,
     name,
     renderProductDetailUrl,
     stock = 0,
     showPrice,
     showStock,
     unlimited,
     showBackOrder,
     showSaving
   }) {
  const stockQuantity = unlimited ? 9999 : stock

  return (
    <div className="o-grid c-pdp__details" data-testid="pdp-details">
      <div className="o-grid__item u-1/4">
        <Image className="c-pdp__details-image" alt={name} image={imageUrl} />
      </div>
      <div className="o-grid__item">
        <div className="c-pdp__details-container">
          <h3 className="u-h5 u-text-bold u-margin-bot-small">{name}</h3>
          <PartNumbers
            className={cn({ 'u-margin-bot-none': isOnMobile })}
            inline
            insightPart={materialId}
            mfrPart={manufacturerId}
          />
          {isOnMobile && renderProductDetailUrl()}
          <div className="o-grid o-grid--justify-between c-pdp__pricing-container">
            <div className="o-grid__item u-4/5 c-pdp__pricing-containerstock">
              <Pricing
                abbreviation={abbreviation}
                contractDiscount={contractDiscount}
                currencyCode={currencyCode}
                displayDiscount={displayDiscount}
                displayListPrice={displayListPrice}
                hasContractSection={hasContractSection}
                isLoggedIn={isLoggedIn}
                isIPSUser={isIPSUser}
                showPrice={showPrice}
                listPrice={listPrice}
                webPrice={webPrice}
                priceInclVat={priceInclVat}
                showSaving={showSaving}
              />
              {showStock && (
                <div className="o-grid u-margin-top-tiny u-margin-bot-tiny">
                  <span className="o-grid__item o-grid__item--shrink">
                    <SimpleStockInfo
                      stock={stockQuantity}
                      showBackOrder={showBackOrder}
                    />
                  </span>
                </div>
              )}
            </div>
            <div className="o-grid__item u-1/5">
              <div className="o-grid o-grid--justify-right u-margin-top-tiny">
                <Button color="none" href={productLandingPage(mfrName)}>
                  <Image image={manufacturerImage} alt={mfrName} />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

PDPDetails.propTypes = {
  displayListPrice: PropTypes.bool,
  imageUrl: PropTypes.string.isRequired,
  isIPSUser: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isOnMobile: PropTypes.bool,
  listPrice: PropTypes.number,
  webPrice: PropTypes.number,
  priceInclVat: PropTypes.number,
  manufacturerId: PropTypes.string.isRequired,
  mfrName: PropTypes.string.isRequired,
  manufacturerImage: PropTypes.string.isRequired,
  materialId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  renderProductDetailUrl: PropTypes.func.isRequired,
  showPrice: PropTypes.bool,
  showStock: PropTypes.bool,
  stock: PropTypes.number,
  showBackOrder: PropTypes.bool,
}

PDPDetails.defaultProps = {
  displayListPrice: false,
  isLoggedIn: false,
  isIPSUser: false,
  showStock: true,
  showBackOrder: false,
}

export default connectToLocale(PDPDetails)
